import { ConfigProvider, message } from "antd";
import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../store/reduxHooks";
import {
  IApiManagerRequest,
  useAddManagerMutation,
} from "../../../../store/api/listManager.api";
import { useNavigate } from "react-router-dom";
import classes from "./RegistrationNewManager.module.css";
import { AttachPersonToManager } from "../../shared/AttachPersonToManager/AttachPersonToManager";
import {
  setIsEditForm,
  setManager,
} from "../../../../store/slice/adminManagerSlice/adminManagerSlice";
import { MANAGER_FORM_ID } from "../../../../constants/adminManagerInfo/managerFormId";
import { ManagerForm } from "../../shared/ManagerForm/ManagerForm";
import { useForm } from "antd/es/form/Form";
import { useUnmountClearManagerInfo } from "../../../../utils/Hooks/adminManagerInfo/useUnmountClearManagerInfo";
import { useAttachPersonToManager } from "../../../../utils/Hooks/adminManagerInfo/useAttachPersonToManager";
import { AdminManagerBottomPanel } from "../../shared/BottomPanel/AdminManagerBottomPanel";
import { AttachPersonManagerList } from "../../shared/attachPersonList/AttachPersonList";

export const RegistrationNewManager: FC = () => {
  const [form] = useForm();
  const [addManager, { isLoading: isLoadingAddManager }] =
    useAddManagerMutation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const createManagerInfo = useAppSelector(
    (state) => state.adminManagerInfoSlice.currentManager,
  );

  const onCreateManagerFinish = (values: Omit<IApiManagerRequest, "id">) => {
    addManager({
      ...values,
      phone_number: values.phone_number?.replace(/\D/g, ""),
    })
      .unwrap()
      .then((result) => {
        message.success(result.message);
        dispatch(setManager(result.data));
        dispatch(setIsEditForm(false));
      })
      .catch((result) => {
        message.error(result.data.message);
      });
  };

  useEffect(() => {
    dispatch(setIsEditForm(true));
  }, []);

  const {
    attachPersonFormFinish,
    onHandleReattachPersonToCurrentManager,
    isLoadingReattach,
    isLoadingAttach,
    reattachErrorManagerName,
    reattachErrorModalOpen,
    handleCancelReattachModal,
  } = useAttachPersonToManager();

  useUnmountClearManagerInfo();

  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            itemMarginBottom: 0,
            colorTextLabel: "rgba(0, 0, 0, 0.5)",
          },
        },
      }}
    >
      <ManagerForm
        isEdit
        onFinish={onCreateManagerFinish}
        disabled={!!createManagerInfo}
        formId={MANAGER_FORM_ID}
        formInstance={form}
      />
      {createManagerInfo && (
        <AttachPersonToManager
          personConnectManagerName={reattachErrorManagerName || undefined}
          cancelReconnectButtonProps={{
            onClick: handleCancelReattachModal,
          }}
          formProps={{
            onFinish: attachPersonFormFinish,
            className: classes.formattachPerson,
          }}
          modalProps={{
            open: reattachErrorModalOpen,
          }}
          reattachButtonProps={{
            onClick: onHandleReattachPersonToCurrentManager,
            disabled: isLoadingReattach,
            loading: isLoadingReattach,
          }}
          attachButtonProps={{
            loading: isLoadingAttach,
            disabled: isLoadingAttach,
          }}
        />
      )}
      <AttachPersonManagerList />
      {!createManagerInfo && (
        <AdminManagerBottomPanel
          submitButtonProps={{
            loading: isLoadingAddManager,
            disabled: isLoadingAddManager,
          }}
          cancelButtonProps={{
            onClick: () => {
              navigate(-1);
            },
          }}
        />
      )}
    </ConfigProvider>
  );
};
